var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGpsTrackOrange = function SvgGpsTrackOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "gps-track--orange_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".gps-track--orange_svg__st0{fill:#ff7101}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4 45H26.6c-.5 0-.8-.5-.6-.9l2.8-6.6c.5-1.2 1.7-2 2.9-2h16.6c1.3 0 2.4.8 2.9 2l2.8 6.6c.2.4-.1.9-.6.9zM24.8 54.4c0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4zM50.4 54.4c0-1.3 1.1-2.4 2.4-2.4s2.4 1.1 2.4 2.4c0 1.3-1.1 2.4-2.4 2.4s-2.4-1.1-2.4-2.4z",
    className: "gps-track--orange_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.4 32.4c-.5-.3-1.2-.9-2.1-1.6H30c-3 0-5.6 1.9-6.4 4.7l-4.4 12.2v20.8c0 .9.8 1.7 1.7 1.7h4.7c.9 0 1.7-.8 1.7-1.7v-4.8c0-.3.3-.6.6-.6h24.2c.3 0 .6.3.6.6v4.8c0 .9.8 1.7 1.7 1.7h4.7c.9 0 1.7-.8 1.7-1.7V47.6l-4.4-12.2c-.9-2.8-3.5-4.7-6.4-4.7h-7.1c-.9.7-1.6 1.3-2.1 1.6-.7.2-1 .2-1.4.1zm15.3 14H25.3c-.9 0-1.5-.9-1.2-1.7L27 37c.7-1.9 2.6-3.2 4.6-3.2h16.8c2 0 3.9 1.3 4.6 3.2l2.9 7.7c.4.8-.3 1.7-1.2 1.7zm2.1 8c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4zm-29.6 4c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ff7101"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 44.8H64c.7 0 1.3.6 1.3 1.3v.6c0 1.8-1.4 3.2-3.2 3.2h-4.5v-5.1zM22.1 44.8h-6.4c-.7 0-1.3.6-1.3 1.3v.6c0 1.8 1.4 3.2 3.2 3.2h4.5v-5.1z",
    className: "gps-track--orange_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40 10.1c-4.8 0-8.8 4-8.8 9 0 5.2 6.6 10.3 8.4 11.7.3.2.6.2.9 0 1.8-1.3 8.4-6.4 8.4-11.7-.1-5-4.1-9-8.9-9zm0 9c-1.6 0-2.9-1.3-2.9-3s1.3-3 2.9-3c1.6 0 2.9 1.3 2.9 3s-1.3 3-2.9 3z",
    style: {
      fill: "#0b1b34"
    }
  }));
};
export default SvgGpsTrackOrange;